export const copyTextToClipboard = (text) => {
  if (!navigator.clipboard) {
    return;
  }

  return navigator.clipboard.writeText(text);
};